export default __webpack_public_path__ + "static/media/community.e5137c04.jpg";